import service from './service'

import apiList from './apiList'
import {isObject, isString} from "lodash";

export default function api(api, params) {
    if (isString(api)) {
        let apiName = api;
        for (let i in apiList) {
            if (apiName === apiList[i]['apiName']) {
                return service({
                    url: apiList[i]['url'],
                    method: apiList[i]['method'],
                    params: apiList[i]['method'] === 'get' ? params : '',
                    data: params
                })
            }
        }
    }else if (isObject(api)) {
        return service({
            url: api['url'],
            method: api['method'],
            params: api['method'] === 'get' ? params : '',
            data: params
        })
    }
    return false;
}



